import React, { useEffect, useRef } from "react";
import { isSameTime } from "@repo/utils";
import { addMinutes, differenceInMinutes, format, set } from "date-fns";

import { Button } from "./button";

export default function TimePicker({
  value,
  onChange,
}: {
  value: Date;
  onChange: (value: Date) => void;
}) {
  const start = set(value, {
    hours: 7,
    minutes: 0,
    seconds: 0,
    milliseconds: 0,
  });

  const end = set(value, {
    hours: 23,
    minutes: 45,
    seconds: 0,
    milliseconds: 0,
  });

  const timeBetween = differenceInMinutes(end, start);

  const amountOfTimeslots = timeBetween / 15;

  const selectedButtonRef = useRef<HTMLButtonElement | null>(null);

  useEffect(() => {
    if (selectedButtonRef.current) {
      selectedButtonRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [value]);

  return (
    <div className="grid grid-cols-4 gap-8">
      {Array.from({ length: amountOfTimeslots + 1 }).map((_, idx) => {
        const currentTime = addMinutes(start, idx * 15);
        const isCurrentTime = isSameTime(value, currentTime);

        return (
          <Button
            ref={isCurrentTime ? selectedButtonRef : null}
            key={currentTime.getTime()}
            type="button"
            onClick={() => onChange(currentTime)}
            variant={isCurrentTime ? "default" : "outline"}
          >
            {format(currentTime, "HH:mm")}
          </Button>
        );
      })}
    </div>
  );
}
